import { THREE } from './three'
import { FOV } from './constsants'

export const createCamera = container => {
  const aspect = container.clientWidth / container.clientHeight
  const near = 1
  const far = 200
  return new THREE.PerspectiveCamera(FOV, aspect, near, far)
}
